import React, {useEffect, useState} from 'react';
import {useQuery} from '@apollo/client';
import {Grid} from '@mui/material';
import {AtualizaPerfilContainer} from '../containers/atualiza-perfil';
import {RedefinirSenhaContainer} from '../containers/redefinir-senha';
import {
  GET_COMERCIAL_LOGADO,
  TOTAL_CAMPANHA_POR_CIDADE,
} from '../graphql/queries';
import MapaCidades from '../containers/mapas/mapa-cidades';

const Perfil = () => {
  const comercialQuery = useQuery(GET_COMERCIAL_LOGADO);
  const localizacoesQuery = useQuery(TOTAL_CAMPANHA_POR_CIDADE);

  const [comercial, setComercial] = useState(undefined)
  const [localizacoes, setLocalizacoes] = useState([]);
  const [redefinirSenha, setRedefinirSenha] = useState(false);

  useEffect(() => {
    if (localizacoesQuery.loading || localizacoesQuery.error) return;

    setLocalizacoes(localizacoesQuery.data?.totais || []);
  }, [localizacoesQuery]);

  useEffect(() => {
    if (comercialQuery.loading || comercialQuery.error) return;

    setComercial(comercialQuery.data?.comercial || {});
  }, [comercialQuery]);

  return (
    <Grid container sx={styles.container}>
      <Grid item xs={4} md={3} sx={styles.infoContainer}>
        {comercial && redefinirSenha && (
          <RedefinirSenhaContainer
            comercial={comercial}
            onClose={() => setRedefinirSenha(false)}
          />
        )}
        {comercial && !redefinirSenha && ((
          <AtualizaPerfilContainer
            comercial={comercial}
            onClickRedefinirSenha={() => setRedefinirSenha(true)}
          />
        ))}
      </Grid>
      <Grid item xs={8} md={9}>
        <MapaCidades sx={styles.mapa} localizacoes={localizacoes} />
      </Grid>
    </Grid>
  );
};

const styles = {
  container: {
    height: '100%',
    width: '100%'
  },
  infoContainer: {
    backgroundColor: theme => theme.palette.paterns.white,
    boxShadow: '0px 6px 12px rgb(0 0 0 / 20%)',
    zIndex: 2
  },
  mapa: {
    height: 'calc(100vh - 61px)'
  }
};

export default Perfil;
